export type PrometheusValkeyTotalKeysStatsBackendApiProps = {
    created: number;
    db_keys: number;
};

export default class PrometheusValkeyTotalKeysStats {
    readonly created: number;
    readonly dbKeys: number;

    constructor(props: PrometheusValkeyTotalKeysStatsBackendApiProps) {
        this.created = props.created;
        this.dbKeys = props.db_keys;
    }
}
